import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';

const config = {
  apiKey: 'AIzaSyBC1E15ksvJmvJIau_jsEb3WXGNb9t0mJQ',
  authDomain: 'enexan.firebaseapp.com',
  projectId: 'enexan',
  storageBucket: 'enexan.firebasestorage.app',
  messagingSenderId: '591431042093',
  appId: '1:591431042093:web:e4e76f2995cb442809a4a4',
};

if (!config) {
  throw new Error('Invalid Firebase configuration - missing environment variables');
}

const firebaseApp = initializeApp(config);
const auth = getAuth(firebaseApp);

export { firebaseApp, auth };
